export const CompanyCard: React.FC<{ name: string; link: string; overview: string; icon: React.ReactNode }> = ({
    name,
    link,
    overview,
    icon,
  }) => {
    return (
      <div className="border rounded-lg p-6 shadow-md bg-white">
        {/* Icon */}
        <div className="mb-4">{icon}</div>
  
        {/* Company Name */}
        <h2 className="text-xl font-bold mb-2">{name}</h2>
  
        {/* Overview */}
        <h3 className="text-lg font-semibold mb-1">Overview</h3>
        <p className="text-gray-700 mb-4">{overview}</p>
  
        {/* Button */}
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 px-6 py-3 bg-[var(--color-brand)] text-white font-semibold rounded-md transition hover:bg-transparent hover:border-2 hover:border-[var(--color-brand)] hover:text-[var(--color-brand)]"
     
        >
          Visit Website
        </a>
      </div>
    );
  };